import { render, staticRenderFns } from "./StammBaseList.vue?vue&type=template&id=950f99e4&scoped=true"
import script from "./StammBaseList.vue?vue&type=script&lang=ts"
export * from "./StammBaseList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950f99e4",
  null
  
)

export default component.exports